var _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDiscord(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 16,
    viewBox: "0 0 19 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.7477 1.69678C14.5825 1.10393 13.3367 0.673069 12.0342 0.427734C11.8742 0.742244 11.6873 1.16527 11.5585 1.50178C10.1739 1.27534 8.802 1.27534 7.44287 1.50178C7.31404 1.16527 7.12292 0.742244 6.96152 0.427734C5.65761 0.673069 4.41032 1.10551 3.24514 1.69992C0.894982 5.56202 0.257892 9.32819 0.576437 13.0409C2.13519 14.3068 3.64581 15.0757 5.13093 15.579C5.49762 15.0301 5.82465 14.4468 6.10638 13.8319C5.56981 13.6101 5.0559 13.3365 4.57031 13.0189C4.69913 12.9151 4.82514 12.8066 4.94689 12.695C7.90864 14.2014 11.1267 14.2014 14.0531 12.695C14.1762 12.8066 14.3022 12.9151 14.4296 13.0189C13.9426 13.3381 13.4273 13.6117 12.8907 13.8335C13.1725 14.4468 13.4981 15.0318 13.8662 15.5805C15.3527 15.0773 16.8647 14.3083 18.4235 13.0409C18.7973 8.73693 17.785 5.00534 15.7477 1.69678ZM6.50988 10.7576C5.62079 10.7576 4.89166 9.85498 4.89166 8.7558C4.89166 7.6566 5.60522 6.75242 6.50988 6.75242C7.41457 6.75242 8.14366 7.65502 8.12809 8.7558C8.1295 9.85498 7.41457 10.7576 6.50988 10.7576ZM12.4901 10.7576C11.601 10.7576 10.8718 9.85498 10.8718 8.7558C10.8718 7.6566 11.5854 6.75242 12.4901 6.75242C13.3947 6.75242 14.1238 7.65502 14.1083 8.7558C14.1083 9.85498 13.3947 10.7576 12.4901 10.7576Z",
    fill: "url(#paint0_linear_123_5704)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_123_5704",
    x1: 0.5,
    y1: 8.06572,
    x2: 18.5,
    y2: 8.06572,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF91FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#47D7AC"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscord);
export default __webpack_public_path__ + "static/media/discord.5a9f564b1a60fad71aae3ccded9f7108.svg";
export { ForwardRef as ReactComponent };